import { useEffect, useState } from "react";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { apiURI, authErrorRedirect, DataGridTable } from "../../common";
import { useNavigate } from "react-router-dom";
import { AddSupplierToMasterDialog } from "./AddSupplierToMasterDialog.widget";

function CreateListColumns() {
  let tableColumns = [
    {
      field: "supplierId",
      headerName: "Supplier ID",
      type: "number",
      flex: 1,
      maxWidth: 120,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "supplierName",
      headerName: "Supplier Name",
      type: "string",
      flex: 1,
      minWidth: 150,
      align: "left",
      headerAlign: "left",
    },
  ];
  return tableColumns;
}

export function SupplierListMaster() {
  const [errors, setErrors] = useState();
  const [data, setData] = useState([]);
  const history = useNavigate();

  const [openAddSupplierDialog, setOpenAddSupplierDialog] = useState(false);
  const handleOpenAddSupplierDialog = () => {
    setOpenAddSupplierDialog(true);
  };

  const title = "All Users";
  const description = "Click on a row to manage the user's privileges";
  const addUserButton = (
    <Grid item>
      <Button
        variant="contained"
        sx={{ mr: "20px" }}
        onClick={() => handleOpenAddSupplierDialog()}
      >
        Add Supplier
      </Button>
    </Grid>
  );

  useEffect(() => {
    axios
      .get(`${apiURI}/form/getSupplierList`)
      .then(async (response) => {
        console.log(response.data);
        const suppliersArray = [];
        await response.data[0].supplierList.forEach((item, i) => {
          suppliersArray.push({
            supplierId: item.split("-")[0],
            supplierName: item.split("-")[1],
          });
        });
        setData(suppliersArray);
      })
      .catch((response) => {
        console.log("error in axios form call react");
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });
    // eslint-disable-next-line no-console
  }, []);
  return (
    <Grid
      justifyContent="center"
      alignItems="center"
      sx={{
        marginLeft: "auto",
        marginRight: "auto",
        padding: 3,
      }}
    >
      <DataGridTable
        data={data}
        createColumns={CreateListColumns}
        title={title}
        description={description}
        button={addUserButton}
      />

      <AddSupplierToMasterDialog
        open={openAddSupplierDialog}
        setOpen={setOpenAddSupplierDialog}
        handleOpen={handleOpenAddSupplierDialog}
      />
    </Grid>
  );
}
